import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract and normalize a domain from a URL or email address.
 * Examples:
 *   "https://www.ampati.com/page" → "ampati.com"
 *   "info@ampati.com" → "ampati.com"
 *   "" → null
 */
export function extractDomain(input: string | null | undefined): string | null {
  if (!input || !input.trim()) return null;
  
  let domain = input.trim().toLowerCase();
  
  // If it's an email, take the part after @
  if (domain.includes('@')) {
    domain = domain.split('@')[1] || '';
  } else {
    // Remove protocol
    domain = domain.replace(/^https?:\/\//, '');
    // Remove www.
    domain = domain.replace(/^www\./, '');
    // Remove path, query, fragment
    domain = domain.split('/')[0].split('?')[0].split('#')[0];
  }
  
  // Remove port if present
  domain = domain.split(':')[0];
  
  return domain || null;
}
